module.exports = __webpack_public_path__ + "img/chinesecompany109.225bffa5.png";